<app-header></app-header>
<ion-content
  id="product-usage-page"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <div class="page-content-wrapper">
    <div
      class="header-wrapper"
      *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
    >
      <app-breadcrumb activePageName="Product Usage"></app-breadcrumb>
      <ion-grid fixed="true">
        <ion-row class="title-row">
          <ion-col>
            <h1 class="page-title">PRODUCT USAGE</h1>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div class="content-container">
      <ion-grid fixed="true">
        <ion-row
          class="toast-container"
          *ngIf="(platformService?.platformType === platformService?.platformEnum?.tablet) 
        || (platformService?.platformType === platformService?.platformEnum?.mobile)"
        >
          <ion-col>
            <app-data-usage-warning></app-data-usage-warning>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <app-footer></app-footer>
</ion-content>
